//uses mmenu-js

class MegaNav {
    mmenu = {
        menu : null,
        api: null,
        button: null,
        hamburger: `<button class="hamburger hamburger--squeeze" type="button">
                        <span class="hamburger-box">
                            <span class="hamburger-inner"></span>
                        </span>
                        <span class="hamburger-label">Menu</span>
                    </button>  `
    }
    featured_content = {
        'for-teachers': null,
        'for-parents': null,
        'for-leaders': null,
    }
    children_class = '.menu-item-has-children'
    content_class = '.featured-content'
    content_api = '/wp-json/catalyst/v1/nav-cta/'
    content_item_tmpl = `
        <a href="{{url}}" target="{{target}}" class="featured-content">
            <div class="img" style="background-image:url('{{img}}')"></div>
            <div class="title">{{title}}</div>
            <div class="excerpt">{{excerpt}}</div>
            <div class="link">{{cta_text}}</div>
        </a>
    `

    constructor() {
        this.init()
    }

    async init() {
        await this.getFeaturedContent()
        this.loadFeaturedContent()
        this.mobileMenu()
    }

    mobileMenu() {
        const _t = this;

        $('.tm-header nav .uk-navbar-nav .mobile-menu > a').replaceWith(_t.mmenu.hamburger)
        _t.mmenu.button = $('.hamburger')
        _t.mmenu.menu = new Mmenu('#mobile-menu', {
            offCanvas: {
                position: 'right-front'
            },
            hooks: {
                'closePanel:before' : () => { }
            }
        })
        _t.mmenu.api = _t.mmenu.menu.API
        _t.mmenu.button.on('click', (e) => {
            e.preventDefault()
            _t.mmenu.button.addClass('is-active')
            _t.mmenu.api.open()
        })

        $('#mobile-menu').attrchange({
            trackValues: true, 
            callback: function (event) {
              if(event.attributeName === 'class' && event.newValue.indexOf('mm-menu--opened') === -1) _t.mmenu.button.removeClass('is-active')
            }
        });

        $(window).on('resize', () => {
            if($('#mobile-menu').hasClass('mm-menu--opened')) _t.mmenu.api.close()
        })
    }

    getFeaturedContent() {
        return new Promise(resolve => {
            const requests = Object.keys(this.featured_content).map(feature => 
                this.request(feature).then(result => {
                    this.featured_content[feature] = result;
                    return result;
                })
            );

            Promise.all(requests).then(() => {
                resolve();
            });
        });
    }

    request(type) {
        return new Promise((resolve, reject) => {
            $.get(this.content_api + type, (data) => {
                resolve(data);
            }).fail(reject);
        });
    }

    loadFeaturedContent() {
        $('.menu-item.featured-content').each(async (i, e) =>  this.getContent($(e)))
    }

    async getContent(item) {
        let type = Array.from(item[0].classList).find(cls => cls.startsWith('for-'))
        this.renderFeaturedContent(item, this.featured_content[type])
    }

    renderFeaturedContent(item, content_item) {
        if(content_item.title == '') return

        let parent = $(item).closest('.uk-navbar-dropdown-nav')
        let content = this.content_item_tmpl
            .replace('{{title}}', content_item.title)
            .replace('{{excerpt}}', content_item.excerpt)
            .replace('{{img}}', content_item.img)
            .replace('{{cta_text}}', content_item.cta_text)
            .replace('{{url}}', content_item.cta_link.url)
            .replace('{{target}}', content_item.cta_link.target)
        

        //if is Mobile
        if($(item).closest('.uk-nav-sub').length) {
            $(item)
                .addClass('featured-cta')
                .removeClass(this.content_class.substring(1))
                .html(content)
        } 
        else {
            $(item).remove()
            $(content).insertAfter(parent)
        }
        
    }

}

$(() => new MegaNav())